<template>
  <div class="navigation-icon">
    <component :is="iconComponent"/>
  </div>
</template>

<script>
import HomeIcon from './icons/HomeIcon'
import MarketingIcon from './icons/MarketingIcon'
import UsersIcon from './icons/UsersIcon'

export default {
  name: 'NavigationIcon',
  components: {
    HomeIcon,
    MarketingIcon,
    UsersIcon,
  },
  props: {
    name: {
      required: true,
      validator: v => [
        'home',
        'marketing',
        'users',
      ].includes(v),
    },
  },
  data() {
    return {
      components: {
        /* eslint-disable quote-props */
        'home': 'HomeIcon',
        'marketing': 'MarketingIcon',
        'users': 'UsersIcon',
        /* eslint-enable quote-props */
      },
    }
  },
  computed: {
    iconComponent() {
      return this.components[this.name] || ''
    },
  },
}
</script>

<style lang="scss" scoped>
  .navigation-icon {
    display: inline-block;
    margin-right: 8px;
  }
</style>

<style lang="scss">
@import '~@/assets/styles/base/_color.scss';
.navigation-icon svg {
  margin-bottom: 6px;
}

.el-submenu
.el-submenu__title
.navigation-icon,
.el-menu-item
.navigation-icon {
  svg > g > *, {
    stroke: $color-primary;
  }
  #marketing-icon-triangle {
    fill: $color-primary;
  }
}

// Apply primary fill to navigation icon groups
.el-submenu.is-active
.el-submenu__title
.navigation-icon,
.el-menu-item.is-active
.navigation-icon {
  margin-left: -3px;
  svg .override-fill {
    fill: $color-primary;
  }
  svg .override-stroke {
    stroke: $color-primary;
  }
  #marketing-icon {
    rect {
      stroke: none;
      fill: $color-primary;
    }
    path {
      stroke: #ffffff;
      fill: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationIcon.vue